<!-- Уведомление о смене калькулятора с повтором значений предыдущей версии. -->
<template>
  <div class="plan-switch-notice" role="status">
    <span class="plan-switch-notice__check" aria-hidden="true">✓</span>
    <span class="plan-switch-notice__message">
      ПЛАН пересчитан по калькулятору <strong>«{{ calculatorName }}»</strong> —
      версия v{{ version }}. Итог теперь «{{ resultName }}».
    </span>
    <PlanCalculationActionButton
      class="plan-switch-notice__restore"
      appearance="soft"
      :disabled="isCalculating"
      @click="$emit('repeat-values')"
    >
      {{ isCalculating ? "Повторяем значения…" : `Повторить значения v${previousVersion}` }}
    </PlanCalculationActionButton>
    <button
      class="plan-switch-notice__close"
      type="button"
      aria-label="Закрыть уведомление"
      @click="$emit('close')"
    >
      <AppIcon name="close" :size="16" />
    </button>
  </div>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";
import PlanCalculationActionButton from "@/components/Order/PlanCalculation/Buttons/Action.vue";

export default {
  name: "OrderPlanCalculationSwitchNotice",

  components: { AppIcon, PlanCalculationActionButton },

  props: {
    calculatorName: { type: String, required: true },
    resultName: { type: String, required: true },
    version: { type: Number, required: true },
    previousVersion: { type: Number, required: true },
    isCalculating: { type: Boolean, default: false },
  },

  emits: ["repeat-values", "close"],
};
</script>

<style scoped>
.plan-switch-notice {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  background: #ecfdf3;
  color: #14532d;
  font-size: 13px;
}

.plan-switch-notice__check {
  flex: none;
}
.plan-switch-notice__message {
  min-width: 0;
}
.plan-switch-notice__restore {
  flex: none;
  margin-left: auto;
}

.plan-switch-notice__close {
  width: 28px;
  height: 28px;
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: #4b7a5c;
  cursor: pointer;
}

.plan-switch-notice__close:hover,
.plan-switch-notice__close:focus-visible {
  background: #dcfce7;
  outline: none;
}

@media (max-width: 768px) {
  .plan-switch-notice {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .plan-switch-notice__message {
    flex: 1 1 calc(100% - 54px);
  }
  .plan-switch-notice__restore {
    margin-left: 26px;
  }
  .plan-switch-notice__close {
    order: -1;
    margin-left: auto;
  }
}
</style>
